import { useIsEuCustomerQuery } from '../apis/geoLocationApi';
import { useCreateAccountMutation } from '../apis/createAccountApi';
import { useEffect, useState } from 'react';
import { AlertType, TowerAlert } from '../../../common/Alerts';
import isEmpty from 'lodash/isEmpty';
import { CommConsentRequest } from '../types';
import { useNextQueryStringValue } from './useQueryString';
import useRedirectOrCloseOnSuccess from './useRedirectOrCloseOnSuccess';

const useCreateAccount = () => {
    const [isProcessing, setIsProcessing] = useState(false);
    const [alerts, setAlerts] = useState<TowerAlert[]>([]);
    const next = useNextQueryStringValue();
    const { data: isEU = false } = useIsEuCustomerQuery();
    const [createAccount, { data: createAccountResult, isError, error }] =
        useCreateAccountMutation();

    // Redirect or close the window on successful account creation
    useRedirectOrCloseOnSuccess(
        createAccountResult?.redirectUrl as string,
        (redirectValue: string) => {
            if (isEmpty(redirectValue)) {
                setIsProcessing(false);
            }
        }
    );

    useEffect(() => {
        if (isError) {
            setIsProcessing(false);
            const defaultErrorMessage = 'Error processing your request.';
            setAlerts([
                {
                    type: AlertType.error,
                    // @ts-ignore
                    message: (error?.data?.message || defaultErrorMessage) as string,
                },
            ]);
        }
    }, [isError, error]);

    const onCreateAccount = (username: string, password: string, doesConsent: boolean) => {
        if (isProcessing) {
            return;
        }

        setAlerts([]);
        setIsProcessing(true);

        const consentRequest: CommConsentRequest = {
            isEU,
            doesConsent: !isEU || doesConsent,
        };
        createAccount({ username, password, consentRequest, next });
    };

    return {
        createAccount: onCreateAccount,
        isLoading: isProcessing,
        isEuCustomer: isEU,
        alerts,
    };
};
export default useCreateAccount;
